import { render, staticRenderFns } from "./CalendarOverview.vue?vue&type=template&id=32b350d4"
import script from "./CalendarOverview.vue?vue&type=script&lang=js"
export * from "./CalendarOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports